export default __webpack_public_path__ + "static/media/ZWIADOWCA.febda3b0.png";